<template>
  <div>
    <PageTitle title="Payments" :permission="'Purchase Create'" />
    <v-container
      fluid
      class="lighten-12 container"
      style="background-color: white"
    >
      <v-flex>
        <v-row>
          <!-- Payments method Component Card -->
          <v-col
            cols="12"
            xs="12"
            sm="12"
            md="4"
            lg="4"
            xl="4"
            style="
              background: linear-gradient(
                to left,
                rgb(244 244 244) 0%,
                rgb(244 244 244) 100%
              ) !important;
            "
            class="d-flex pr-1 pb-2 pt-0"
          >
            <v-card
              class="lighten-12 card-content py-0 topCard"
              width="100%"
              style="background-color: rgb(255, 162, 0, 1)"
              v-if="PaymentList.length > 0"
            >
              <v-row>
                <v-col cols="4" class="text-lg-left font-weight-bold">
                  <!-- <v-icon medium>mdi-sack-percent</v-icon> -->
                  <div class="topCard ml-3">
                    <div>
                      {{
                        PaymentList[0].payment_type
                          ? PaymentList[0].payment_type
                          : 'No Data Available'
                      }}
                    </div>
                  </div>
                </v-col>

                <!-- payment component for card -->
                <v-col
                  cols="4"
                  class="text-lg-center font-weight-bold"
                  v-if="PaymentList[0].payment_type == 'Card'"
                >
                  <div class="topCard">
                    {{ CardPayment[0] ? CardPayment[0] : '0' }}
                  </div>
                </v-col>
                <v-col
                  cols="4"
                  class="text-right font-weight-bold"
                  v-if="PaymentList[0].payment_type == 'Card'"
                >
                  <div class="topCard mr-3">
                    {{ CardPayment[1] ? CardPayment[1] : '0' | formatCurrency }}
                  </div>
                </v-col>

                <!-- payment component for cash -->
                <v-col
                  cols="4"
                  class="text-center font-weight-bold"
                  v-if="PaymentList[0].payment_type == 'Cash'"
                >
                  <div class="topCard">
                    {{ CashPayment[0] ? CashPayment[0] : '0' }}
                  </div>
                </v-col>
                <v-col
                  cols="4"
                  class="text-end font-weight-bold"
                  v-if="PaymentList[0].payment_type == 'Cash'"
                >
                  <div class="topCard mr-3">
                    {{ CashPayment[1] ? CashPayment[1] : '0' | formatCurrency }}
                  </div>
                </v-col>

                <!-- payment component for cheque -->
                <v-col
                  cols="4"
                  class="text-lg-center font-weight-bold"
                  v-if="PaymentList[0].payment_type == 'Cheque'"
                >
                  <div class="topCard">
                    {{ ChequePayment[0] ? ChequePayment[0] : '0' }}
                  </div>
                </v-col>
                <v-col
                  cols="4"
                  class="text-end font-weight-bold"
                  v-if="PaymentList[0].payment_type == 'Cheque'"
                >
                  <div class="topCard mr-3">
                    {{
                      ChequePayment[1] ? ChequePayment[1] : '0' | formatCurrency
                    }}
                  </div>
                </v-col>
              </v-row>
            </v-card>
          </v-col>

          <!-- Payments from Component Card -->
          <v-col
            cols="12"
            xs="12"
            sm="12"
            md="4"
            lg="4"
            xl="4"
            style="
              background: linear-gradient(
                to left,
                rgb(244 244 244) 0%,
                rgb(244 244 244) 100%
              ) !important;
            "
            class="d-flex pr-1 pb-2 pt-0"
          >
            <v-card
              class="lighten-12 card-content py-0 topCard"
              width="100%"
              style="background-color: rgb(75, 171, 70, 1)"
              v-if="PaymentList.length > 0"
            >
              <v-row>
                <v-col cols="4" class="text-lg-left font-weight-bold">
                  <!-- <v-icon medium>mdi-sack-percent</v-icon> -->
                  <div class="topCard ml-3">
                    <div>
                      {{ PaymentList[0].paymentable_type }}
                    </div>
                  </div>
                </v-col>

                <!-- payment from purchase component -->
                <v-col
                  cols="4"
                  class="text-lg-center font-weight-bold"
                  v-if="PaymentList[0].paymentable_type == 'purchase'"
                >
                  <div class="topCard mr-3">
                    {{ FromPurchase[0] ? FromPurchase[0] : '0' }}
                  </div>
                </v-col>
                <v-col
                  cols="4"
                  class="text-right font-weight-bold"
                  v-if="PaymentList[0].paymentable_type == 'purchase'"
                >
                  <div class="topCard mr-3">
                    {{
                      FromPurchase[1] ? FromPurchase[1] : '0' | formatCurrency
                    }}
                  </div>
                </v-col>

                <!-- payment from sale component -->
                <v-col
                  cols="4"
                  class="text-center font-weight-bold"
                  v-if="PaymentList[0].paymentable_type == 'sale'"
                >
                  <div class="topCard">
                    {{ FromSale[0] ? FromSale[0] : '0' }}
                  </div>
                </v-col>
                <v-col
                  cols="4"
                  class="text-right font-weight-bold"
                  v-if="PaymentList[0].paymentable_type == 'sale'"
                >
                  <div class="topCard mr-3">
                    {{ FromSale[1] ? FromSale[1] : '0' | formatCurrency }}
                  </div>
                </v-col>

                <!-- payment from other component -->
                <v-col
                  cols="4"
                  class="text-lg-center font-weight-bold"
                  v-if="PaymentList[0].paymentable_type == 'other'"
                >
                  <div class="topCard mr-3">
                    {{ FromOther[0] ? FromOther[0] : '0' }}
                  </div>
                </v-col>
                <v-col
                  cols="4"
                  class="text-right font-weight-bold"
                  v-if="PaymentList[0].paymentable_type == 'other'"
                >
                  <div class="topCard mr-3">
                    {{ FromOther[1] ? FromOther[1] : '0' | formatCurrency }}
                  </div>
                </v-col>
              </v-row>
            </v-card>
          </v-col>

          <!-- total payments component -->
          <v-col
            cols="12"
            xs="12"
            sm="12"
            md="4"
            lg="4"
            xl="4"
            style="
              background: linear-gradient(
                to left,
                rgb(244 244 244) 0%,
                rgb(244 244 244) 100%
              ) !important;
            "
            class="d-flex pr-1 pb-2 pt-0"
          >
            <v-card
              class="lighten-12 card-content py-0 topCard"
              width="100%"
              style="background-color: rgb(87, 87, 87, 1)"
              v-if="PaymentList.length > 0"
            >
              <v-row>
                <v-col cols="4" class="text-lg-left font-weight-bold">
                  <!-- <v-icon medium>mdi-sack-percent</v-icon> -->
                  <div class="topCard ml-3 text-no-wrap">
                    <div>Total Payments</div>
                  </div>
                </v-col>
                <v-col cols="4"> </v-col>
                <v-col cols="4" class="text-end font-weight-bold">
                  <div class="topCard mr-3">
                    {{ total | formatCurrency }}
                  </div>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-flex>

      <v-btn :ripple="false" class="min-button" icon @click="show = !show">
        <v-icon color="blue" class="ml-10">
          {{ show ? 'mdi-filter-outline' : 'mdi-filter' }}
        </v-icon>
        <span class="subheading filterclor">Filter</span>
      </v-btn>
      <v-expand-transition>
        <v-card class="lighten-12 card-content" v-show="!show">
          <TableFilters
            :filters="[
              'paymentType',
              'type',
              'search',
              'dateRange',
              'transferStatus',
            ]"
            v-model="filter"
            :columns="columns"
          ></TableFilters>
        </v-card>
      </v-expand-transition>

      <v-card class="lighten-12 mt-2">
        <v-container fluid class="light gray lighten-12 px-3 py-0">
          <ValidationObserver ref="observer">
            <form>
              <v-row v-if="messages.length != 0">
                <v-col>
                  <v-card>
                    <v-card-text>
                      <v-row>
                        <template>
                          <v-alert
                            v-for="msg in messages"
                            :key="msg"
                            class="messages"
                            outlined
                            type="error"
                            >{{ msg }}</v-alert
                          >
                        </template>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
              <v-row>
                <v-card-text class="pa-0">
                  <v-data-table
                    :items-per-page="paginationOptions.perPage"
                    :headers="headers"
                    :items="PaymentList"
                    @click:row="$router.push(`payment/${$event.id}`)"
                    class="row-pointer"
                    hide-default-footer
                  >
                    <template v-slot:no-data>
                      <div class="mt-16 container justify-center item-center">
                        <noData name="Payments" />
                      </div>
                    </template>

                    <template v-slot:item.status="{ item }">
                      <v-chip
                        :x-small="true"
                        class="ma-2"
                        label
                        text-color="white"
                        :color="GetPaymentStatusColor(item.status)"
                        dark
                        ><div>
                          {{ item.status ? item.status : '---------' }}
                        </div></v-chip
                      >
                    </template>
                    <template v-slot:item.user="{ item }">
                      <div>
                        {{ item.user ? item.user.first_name : '---------' }}
                      </div>
                    </template>
                    <template v-slot:item.date_time="{ item }">
                      <div>
                        {{
                          item.date_time
                            ? item.date_time
                            : '---------' | formatDate
                        }}
                      </div>
                    </template>

                    <template v-slot:item.payment_type="{ item }">
                      <div>
                        {{
                          item.payment_type
                            ? item.payment_type
                            : '---------' | formatType
                        }}
                      </div>
                    </template>
                    <template v-slot:item.reference_number="{ item }">
                      <div>
                        {{
                          item.reference_number
                            ? item.reference_number
                            : '---------'
                        }}
                      </div>
                    </template>

                    <template v-slot:item.paymentable_type="{ item }">
                      <div>
                        {{
                          item.paymentable_type
                            ? item.paymentable_type
                            : '---------' | formatType
                        }}
                      </div>
                    </template>

                    <template v-slot:item.amount="{ item }"
                      ><div class="px-4">
                        {{
                          item.amount
                            ? item.amount
                            : '---------' | formatCurrency
                        }}
                      </div></template
                    >

                    <template v-slot:item.actions="{ item }">
                      <v-menu offset-y transition="scroll-x-transition">
                        <template v-slot:activator="{ $attrs, on }">
                          <v-icon v-bind="$attrs" v-on="on"
                            >mdi-dots-vertical</v-icon
                          >
                        </template>
                        <v-list class="actions">
                          <permission-control permissionName="Purchase Show">
                            <v-list-item dense link @click="viewPayment(item)">
                              <span>
                                <v-icon v-bind="$attrs" v-on="on"
                                  >mdi-eye</v-icon
                                >View
                              </span>
                            </v-list-item>
                          </permission-control>
                        </v-list>
                      </v-menu>
                    </template>
                    <template
                      slot="footer"
                      v-if="PaymentList && PaymentList.length > 0"
                      class="black--text"
                    >
                      <v-row>
                        <v-col sm="6" md="10" lg="10" class="title pl-6"
                          >Total</v-col
                        >
                        <v-col
                          class="title text-lg-center text-md-left text-right pr-0 pr-sm-15 pr-md-15 pr-lg-5"
                          >{{
                            grandTotal
                              ? grandTotal
                              : '---------' | formatCurrency
                          }}</v-col
                        >
                      </v-row>
                    </template>

                    <template v-slot:footer="{}">
                      <paginationComponent
                        @paginationOptions="setPaginationOptions"
                        :url="'payments'"
                        :filterAction="true"
                        @getPageNumber="setPagenumber"
                        @response="receivePurchaseData"
                        :filter="filter"
                      />
                      <!-- :url="'purchases-orders'" -->
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-row>
            </form>
          </ValidationObserver>
        </v-container>
      </v-card>
    </v-container>
  </div>
</template>
<script>
import { PurchaseOrder } from '../../../models/EntityModels/PurchaseOrder';
import { required, email, max, numeric } from 'vee-validate/dist/rules';
import noData from '../../../components/shared/noItem';
import TableFilters from '@/components/base/TableFilters';

// Mixins
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from 'vee-validate';

import paginationComponent from '../../shared/components/pagination.vue';
import { mapGetters } from 'vuex';
import { has } from 'lodash';

import confirmation from '../../shared/components/confirmation';

extend('numeric', {
  ...numeric,
  message: 'input must be numeric',
});
export default {
  data: () => ({
    show: 'false',
    on: {
      click: console.log,
      contextmenu: console.log,
    },
    inheritAttrs: false,
    paginationOptions: {},
    messages: [],
    status: ['Pending', 'Canceled', 'Received'],

    columns: [
      {
        text: 'Date',
        value: 'date_time',
        show: true,
        disabled: false,
        width: '10%',
      },

      {
        text: 'Reference Number',
        value: 'reference_number',
        show: true,
        disabled: false,
        width: '10%',
      },
      {
        text: 'Payment type',
        value: 'payment_type',
        show: true,
        align: 'center',
        disabled: false,
        width: '10%',
      },
      {
        text: 'Payment From',
        value: 'paymentable_type',
        align: 'center',
        show: true,
        disabled: false,
        width: '10%',
      },
      {
        text: 'User',
        value: 'user',
        align: 'center',
        show: true,
        disabled: false,
        width: '10%',
      },
      {
        text: 'Payment Amount',
        value: 'amount',
        align: 'right',
        show: true,
        disabled: false,
        width: '10%',
      },

      {
        text: 'Status',
        value: 'status',
        show: true,
        disabled: false,
        align: 'center',
        width: '10%',
      },
      {
        text: 'Actions',
        value: 'actions',
        show: true,
        disabled: true,
        align: 'center',
        width: '10%',
      },
    ],
    PaymentList: [],
    filter: {
      // invoice_status: "",
      paymentType: '',
      start: '',
      end: '',
      type: '',
      // amount: "",
      // supplier: "",
      // search: "",
    },
    menu: false,
    total: 0,
    paid: 0,
    CardPayment: [],
    CashPayment: [],
    ChequePayment: [],
    FromPurchase: [],
    FromSale: [],
    FromOther: [],
  }),
  components: {
    ValidationProvider,
    ValidationObserver,
    paginationComponent,
    noData,
    TableFilters,
  },
  computed: {
    ...mapGetters(['getInvoiceStatusOptions']),
    headers: function () {
      return this.columns.filter((item) => item.show == true);
    },
  },
  methods: {
    setPaginationOptions(data) {
      this.paginationOptions = data;
    },
    setPagenumber(event) {
      this.$router.push('?page=' + event);
      this.$store.dispatch('SetProductSize', event);
    },

    // Card payment Calculations
    cardPayment(array, type, field) {
      let value = 0;
      let amount = 0;
      array.forEach((element) => {
        if (element[type] == 'Card') {
          value++;
          amount += parseFloat(element[field]);
        }
      });
      let cardArray = [value, amount];
      return cardArray;
    },

    // Cash payment Calculations
    cashPayment(array, type, field) {
      let value = 0;
      let amount = 0;
      array.forEach((element) => {
        if (element[type] == 'Cash') {
          value++;
          amount += parseFloat(element[field]);
        }
      });
      let cashArray = [value, amount];
      return cashArray;
    },

    // Cheque payment Calculations
    chequePayment(array, type, field) {
      let value = 0;
      let amount = 0;
      array.forEach((element) => {
        if (element[type] == 'Cheque') {
          value++;
          amount += parseFloat(element[field]);
        }
      });
      let chequeArray = [value, amount];
      return chequeArray;
    },

    // from Purchase Component Calculations
    fromPurchase(array, type, field) {
      let value = 0;
      let amount = 0;
      array.forEach((element) => {
        if (element[type] == 'purchase') {
          value++;
          amount += parseFloat(element[field]);
        }
      });
      let purchaseArray = [value, amount];
      return purchaseArray;
    },

    // from Sale total Component Calculations
    fromSale(array, type, field) {
      let value = 0;
      let amount = 0;
      array.forEach((element) => {
        if (element[type] == 'sale') {
          value++;
          amount += parseFloat(element[field]);
        }
      });
      let saleArray = [value, amount];
      return saleArray;
    },

    // from other Component Calculations
    fromOther(array, type, field) {
      let value = 0;
      let amount = 0;
      array.forEach((element) => {
        if (element[type] == 'other') {
          value++;
          amount += parseFloat(element[field]);
        }
      });
      let otherArray = [value, amount];
      return otherArray;
    },

    receivePurchaseData(data) {
      this.PaymentList = data;

      this.total = this.sumField(this.PaymentList, 'amount'); // Total Amount

      this.CardPayment = this.cardPayment(
        // Card
        this.PaymentList,
        'payment_type',
        'amount',
      );
      this.CashPayment = this.cashPayment(
        // Cash
        this.PaymentList,
        'payment_type',
        'amount',
      );
      this.ChequePayment = this.chequePayment(
        //Cheque
        this.PaymentList,
        'payment_type',
        'amount',
      );
      this.FromPurchase = this.fromPurchase(
        // From Purchase
        this.PaymentList,
        'paymentable_type',
        'amount',
      );
      this.FromSale = this.fromSale(
        // From Sale
        this.PaymentList,
        'paymentable_type',
        'amount',
      );
      this.FromOther = this.fromOther(
        // From Sale
        this.PaymentList,
        'paymentable_type',
        'amount',
      );
    },
    GetPaymentStatusColor(status) {
      switch (status) {
        case 'Completed':
          return 'green';
          break;
        case 'Pending':
          return 'orange';
          break;
        case 'Canceled':
          return 'red';
          break;
        case 'Return':
          return '#973a5a';
          break;
        default:
          break;
      }
    },
    ArchiveOrActivePurchase(PaymentList) {
      this.$store
        .dispatch('purchase/ArchiveOrActicePurchase', PurchaseList.id)
        .then((res) => {
          PurchaseList.is_active = !PurchaseList.is_active;
          var msg = PurchaseList.is_active ? 'activated' : 'archived';

          this.$toast.success('Successfully  ' + msg);
        })
        .catch((err) => {
          this.isLoading = false;
          this.messages = err.data.title;
        });
    },
    sumField(array, filed) {
      let value = 0;
      array.forEach((element) => {
        value += parseFloat(element[filed]);
      });
      return value;
    },

    getStatusColor(status) {
      return status ? 'green' : 'gray';
    },

    openConfirmation(PaymentList) {
      confirmation.dialog = true;
      this.$confirm(
        'Do you want to ' +
          (PurchaseList.is_active ? 'Archive' : 'Activate  ') +
          '?',
      ).then((res) => {
        if (res) {
          this.ArchiveOrActivePurchase(PurchaseList);
        }
      });
    },
    viewPayment(payment) {
      this.$router.push(`/payment/${payment.id}`);
    },
    editPurchaseOrder(purchaseOrder) {
      this.$router.push(`/purchase/edit/${purchaseOrder.id}`);
    },
  },
  created() {},
  watch: {},
  filters: {
    hasName: function (value) {
      if (has(value, 'name')) return value.name;
      else return '-';
    },
  },
};
</script>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Source+Sans+Pro&display=swap');

.topCard {
  color: white;
}
.other {
  color: cornflowerblue;
}
.min-button::before {
  display: none;
}
</style>
